<!--suppress JSUnresolvedFunction, JSUnresolvedVariable -->
<template>
  <div :id="uniqueID">
    <v-input
      class="textCard__html-field"
      :prepend-icon="prependIcon"
      :rules="textareaRules()"
      :label="label"
      hide-details="auto"
      hint="Shift+Enter – перенос строки, Enter – новый параграф"
      :persistent-hint="!noBrHint"
    >
      <vue-editor
        v-model="localValue"
        :editor-toolbar="htmlToolbar()"
        :editor-options="editorOptions"
      />
    </v-input>
  </div>
</template>

<script>
import { VueEditor, Quill } from "vue2-editor";

const Delta = Quill.import("delta");
const Break = Quill.import("blots/break");
const Embed = Quill.import("blots/embed");

function lineBreakMatcher() {
  const newDelta = new Delta();
  newDelta.insert({ break: "" });
  return newDelta;
}

class SmartBreak extends Break {
  length() {
    return 1;
  }
  value() {
    return "\n";
  }

  insertInto(parent, ref) {
    Embed.prototype.insertInto.call(this, parent, ref);
  }
}
SmartBreak.blotName = "break";
SmartBreak.tagName = "BR";
Quill.register(SmartBreak);

export default {
  name: "HtmlField",
  components: { VueEditor },
  props: {
    value: {
      type: String,
      default: ""
    },
    prependIcon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: null
    },
    toolbar: {
      type: Array,
      default: null
    },
    noBrHint: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 400
    }
  },
  data: function () {
    return {
      localValue: "",
      style: null,
      editorOptions: {
        modules: {
          clipboard: {
            matchers: [["BR", lineBreakMatcher]]
          },
          keyboard: {
            bindings: {
              linebreak: {
                key: 13,
                shiftKey: true,
                handler: function (range) {
                  let currentLeaf = this.quill.getLeaf(range.index)[0];
                  let nextLeaf = this.quill.getLeaf(range.index + 1)[0];

                  this.quill.insertEmbed(range.index, "break", true, "user");

                  if (
                    nextLeaf === null ||
                    currentLeaf.parent !== nextLeaf.parent
                  ) {
                    this.quill.insertEmbed(range.index, "break", true, "user");
                  }

                  this.quill.setSelection(
                    range.index + 1,
                    Quill.sources.SILENT
                  );
                }
              }
            }
          }
        }
      }
    };
  },
  computed: {
    uniqueID() {
      let result = "";
      const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 12; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
      }
      return result;
    }
  },
  mounted() {
    const css =
      "#" +
      this.uniqueID +
      " .textCard__html-field .ql-editor{ max-height:" +
      this.maxHeight +
      "px }";
    const head = document.head || document.getElementsByTagName("head")[0];
    this.style = document.createElement("style");

    head.appendChild(this.style);

    this.style.setAttribute("type", "text/css");
    if (this.style.styleSheet) {
      // This is required for IE8 and below.
      this.style.styleSheet.cssText = css;
    } else {
      this.style.appendChild(document.createTextNode(css));
    }
  },
  beforeDestroy() {
    this.style.remove();
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.localValue = this.value ? this.value : "";
      }
    },
    localValue() {
      this.$emit("input", this.localValue);
    }
  },
  methods: {
    textareaRules() {
      if (!this.rules) {
        return [
          (v) => !v || v.length <= 16777215 || "Достигнут максимальный размер"
        ];
      }
      return this.rules;
    },
    htmlToolbar() {
      if (!this.toolbar) {
        return [
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"]
        ];
      }
      return this.toolbar;
    }
  }
};
</script>
<style lang="scss">
.textCard__html-field {
  margin-bottom: 16px;

  .quillWrapper {
    width: 100%;
  }

  .ql-editor {
    white-space: normal;
    max-height: 400px;

    p {
      margin-bottom: 8px;
    }
  }
}
</style>
